import ClientActions from './client-actions';
// reducer with initial state
const initialState = {
	clients: [],
	clientData: {},
	newClient: {},
	updatedClient: {},
	isFetchingData: false,
	alertData: {},
	showAlert: false,
	tokenGenerated: false,
	deletedClient: {},
	scopesLinkToClientData: [],
	updatedScopesLinkToClient: false,
	systemContexts: [],
	sessionUser: {},
	totalPages: 0,
	totalRecords: 0,
	pageRecords: 0,
	clientsForScopePage: [],
	totalPagesForScopePageClients: 0,
	totalRecordsForScopePageClients: 0,
	pageRecordsForScopePageClients: 0
};
export default function clientReducer(state = initialState, action) {
	switch (action.type) {
		case ClientActions.API_GET_SYSTEM_CONTEXTS_SUCCESS:
			return { ...state, systemContexts: action.payload };
		case ClientActions.API_GET_CLIENT_DATA_SUCCESS:
			return { ...state, clientData: action.payload };
		case ClientActions.API_EXCHANGE_ACCESS_TOKEN_SUCCESS:
			sessionStorage.setItem('access_token', 'Bearer ' + action.payload.access_token);
			return { ...state, tokenGenerated: true };
		case ClientActions.API_GET_CLIENTS_DATA_SUCCESS:
			return {
				...state,
				clients: action.payload?._embedded?.clients,
				totalPages: action.payload?.page?.totalPages,
				totalRecords: action.payload?.page?.totalElements,
				pageRecords: action.payload?.page?.size
			};
		case ClientActions.API_DELETE_CLIENT_DATA_SUCCESS:
			return { ...state, deletedClient: action.payload };
		case ClientActions.API_POST_CLIENT_DATA_SUCCESS:
			return { ...state, newClient: action.payload };
		case ClientActions.API_PUT_CLIENT_DATA_SUCCESS:
			return { ...state, updatedClient: action.payload };
		case ClientActions.API_GET_SCOPES_PAGE_CLIENTS_DATA_SUCCESS:
			return {
				...state,
				clientsForScopePage: action.payload?._embedded?.clients,
				totalPagesForScopePageClients: action.payload?.page?.totalPages,
				totalRecordsForScopePageClients: action.payload?.page?.totalElements,
				pageRecordsForScopePageClients: action.payload?.page?.size
			};
		case ClientActions.API_GET_SCOPES_LINK_TO_CLIENT_SUCCESS:
			return { ...state, scopesLinkToClientData: action.payload?._embedded?.scopeModelList };
		case ClientActions.API_PUT_SCOPES_LINK_TO_CLIENT_SUCCESS:
			return { ...state, updatedScopesLinkToClient: true };
		case ClientActions.API_CLEAR_SCOPES_LINK_TO_CLIENT:
			return { ...state, scopesLinkToClientData: [] };
		case ClientActions.FETCHING_DATA:
			return { ...state, isFetchingData: true };
		case ClientActions.FETCHING_DATA_DONE:
			return { ...state, isFetchingData: false };
		case ClientActions.APP_SHOW_ALERT:
			return { ...state, showAlert: true, alertData: action.payload };
		case ClientActions.APP_HIDE_ALERT:
			return { ...state, showAlert: false, alertData: {} };
		case ClientActions.API_CLEAR_CLIENT_DATA:
			return { ...state, newClient: {}, clientData: {}, updatedClient: {}, updatedScopesLinkToClient: false, systemContexts: [] };
		case ClientActions.API_GET_SESSION_USER_SUCCESS:
			return { ...state, sessionUser: action.payload };
		default:
			return state;
	}
}
